import React, { FC, ReactElement, useContext, useEffect } from 'react'

import { Layout } from 'antd'
import HeaderApp from 'Components/HeaderApp'
import Loading from 'Components/Loading'
import { ApplicationContext } from 'Context'
import { Route, Routes } from 'react-router'
import Docas from 'Views/Docas'

import InnerContent from '../InnerContent'

const { Content } = Layout

interface IProps {
  modo: number
}

const LayoutDocas = ({ modo }: IProps): ReactElement => {
  const { applicationContext } = useContext(ApplicationContext)

  useEffect(() => {
    if (!applicationContext.usuarioAtual) {
      location.assign('/session-close')
    }
  }, [])

  return (
    <Layout style={{ height: '100vh' }}>
      {applicationContext.loading ? (
        <Loading />
      ) : (
        <>
          <HeaderApp />
          <Content style={{ padding: '64px 20px 10px' }}>
            <Routes>
              <Route path="/" element={<Docas modo={modo} />} />
            </Routes>
          </Content>
        </>
      )}
    </Layout>
  )
}

export default LayoutDocas
